import {
	Button,
	Card,
	CardBody,
	Content,
	ContentVariants,
	EmptyState,
	EmptyStateBody,
	EmptyStateFooter,
	Split,
	SplitItem,
} from "@patternfly/react-core";
import { OutlinedQuestionCircleIcon } from "@patternfly/react-icons";
import { ToolTip } from "@rhc-shared-components/tool-tip";
import { type FC, Fragment } from "react";
import { useHistory, useRouteMatch } from "react-router-dom";
import type { ProductRouteParams } from "../../constants/routerconstants";
import { useProductMetadata } from "../../hooks/useProductMetadata";
import Env from "../../utils/env";

export const ProductContactDetails: FC = () => {
	const history = useHistory();
	const match = useRouteMatch<ProductRouteParams>();
	const { productDetail } = useProductMetadata();
	return (
		<Card isCompact>
			<CardBody>
				<Content>
					<Content component={ContentVariants.h2}>Product contacts</Content>
				</Content>
				{productDetail?.contacts && productDetail?.contacts?.length > 0 ? (
					<Split>
						<SplitItem isFilled>
							<Content>
								<Content
									component={ContentVariants.h3}
									className={"rhc-overview-checklist-wrapper__tooltip-icon-text-wrapper"}
								>
									Product marketing
									<ToolTip buttonAriaLabel={"Show more information "} buttonContent={<OutlinedQuestionCircleIcon />}>
										<div>
											We occasionally need to contact you regarding marketing activities related to your product.
										</div>
									</ToolTip>
								</Content>
								{productDetail?.contacts
									?.filter((item) => item?.type === "Marketing contact")
									.map((elm, index) => (
										<Fragment key={index}>
											{elm?.email_address}
											<br />{" "}
										</Fragment>
									))}
								<Content
									component={ContentVariants.h3}
									className={"rhc-overview-checklist-wrapper__tooltip-icon-text-wrapper"}
								>
									Technical
									<ToolTip buttonAriaLabel={"Show more information"} buttonContent={<OutlinedQuestionCircleIcon />}>
										<div>We occasionally need to contact you regarding certifications related to your product.</div>
									</ToolTip>
								</Content>
								{productDetail?.contacts
									?.filter((item) => item?.type === "Technical contact")
									.map((elm, index) => (
										<Fragment key={index}>
											{" "}
											{elm?.email_address}
											<br />{" "}
										</Fragment>
									))}
							</Content>
						</SplitItem>
						<SplitItem>
							<Button
								variant={"link"}
								onClick={() => {
									history.push(
										`${Env.routePrefix}${Env.productDetailsPrefix}/${match?.params?.productId}/${Env.productInformationPath}/contacts`,
									);
								}}
							>
								Edit
							</Button>
						</SplitItem>
					</Split>
				) : (
					<EmptyState headingLevel="h3" titleText="No contacts specified">
						<EmptyStateBody>Contacts added to your product will be displayed here.</EmptyStateBody>
						<EmptyStateFooter>
							<Button
								variant="primary"
								onClick={() => {
									history.push(
										`${Env.routePrefix}${Env.productDetailsPrefix}/${match?.params?.productId}/${Env.productInformationPath}/contacts`,
									);
								}}
							>
								Add contacts to product
							</Button>
						</EmptyStateFooter>
					</EmptyState>
				)}
			</CardBody>
		</Card>
	);
};
